<template>
  <div>
    <div class="text-center depahead rsu">Login</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <div style="height: 60px; padding-top: 10px">
        <v-img
          style="margin-left: auto; margin-right: auto"
          width="80px"
          src="@/assets/depa.png"
        ></v-img>
      </div>
      <v-container>
        <ValidationObserver ref="observer">
          <div class="depatitle">กรอก E-mail หรือ เบอร์โทร</div>
          <ValidationProvider
            name="อีเมล"
            key="email"
            :rules="{ required: true }"
            v-slot="{ errors }"
          >
            <v-radio-group
              @change="
                input.username = '';
                $refs.observer.reset();
              "
              :error-messages="errors"
              v-model="typecb"
              column
              row
            >
              <v-radio value="email">
                <template v-slot:label>
                  <span
                    style="font-size: 25px; font-weight: 600"
                    class="primary--text"
                  >
                    E-mail
                  </span>
                </template>
              </v-radio>
              <v-radio value="phone">
                <template v-slot:label>
                  <span
                    style="font-size: 25px; font-weight: 600"
                    class="primary--text"
                  >
                    เบอร์โทร
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </ValidationProvider>

          <div class="mt-5">
            <ValidationProvider
              :name="typecb == 'email' ? 'อีเมล' : 'เบอร์โทร'"
              key="email"
              :rules="{ required: true, email: typecb == 'email' }"
              v-slot="{ errors }"
            >
              <v-text-field
                :key="'email'"
                v-if="typecb == 'email'"
                name="email"
                :placeholder="`กรอกอีเมล`"
                :error-messages="errors"
                dense
                v-model="input.username"
                outlined
                style="border-radius: 6px"
              ></v-text-field>
              <v-text-field
                v-else
                name="phoneno"
                :key="'phoneno'"
                :placeholder="'กรอกเบอร์โทร'"
                type="tel"
                v-mask="'##-####-####'"
                :error-messages="errors"
                dense
                v-model="input.username"
                outlined
                style="border-radius: 6px"
              ></v-text-field>
            </ValidationProvider>
            <div style="color: grey">PIN/Password</div>
            <ValidationProvider
              name="PIN/Password"
              key="type"
              :rules="{ required: true }"
              v-slot="{ errors }"
            >
              <v-text-field
                type="password"
                :error-messages="errors"
                v-model="input.password"
                placeholder="กรอก PIN/Password"
                outlined
                dense
                style="border-radius: 6px"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div
            class="mb-2"
            @click="forgetpass"
            style="cursor:pointer;text-align: center;"
          >
            forget password
          </div>
          <div class="submitbtn">
            <v-btn
              depressed
              @click="login"
              class="text-capitalize"
              color="primary"
              block
              :loading="loginloading"
              >Login</v-btn
            >
          </div>
          <div class="text-center mt-2">
            <v-btn
              @click="dialogs.privacyNotice = true"
              style="font-size: 19px; font-weight: 600; color: #152d53"
              class="text-capitalize"
              text
              >Register</v-btn
            >
          </div>
        </ValidationObserver>
      </v-container>
    </div>
    <dialogPrivacyNotice :dialogs="dialogs"> </dialogPrivacyNotice>
    <dialogConsent
      :dialogs="dialogs"
      :consentData="consentData"
      @submit="query.view = 'Registration'"
    >
    </dialogConsent>
  </div>
</template>

<script>
import dialogPrivacyNotice from "../../src/views/Consent//PrivacyNotice.vue";
import dialogConsent from "../../src/views/Consent/Consent";
import dataJs from "../assets/js/consent";
import axios from "axios";
export default {
  components: {
    dialogPrivacyNotice,
    dialogConsent,
  },
  data() {
    return {
      typecb: "email",
      loginloading: false,
      input: {
        username: "",
        password: "",
      },
      dialogs: {
        privacyNotice: false,
        consent: false,
      },
      consentData: dataJs.consent,
    };
  },
  methods: {
    async login() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        var vm = this;
        var data = {
          userid: this.$store.state.userid,
          password: this.input.password,
        };
        if (this.typecb == "phone") {
          this.input.username = this.input.username.replace(/-/g, "");
          data.phone_number = this.input.username;
        } else {
          data.email = this.input.username.toLowerCase();
        }
        vm.loginloading = true;
        axios
          .post(this.serverUrl + "depalogin", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            vm.loginloading = false;
            if (response.data.responsecode == 200) {
              await this.$swal.fire({
                icon: "success",
                text: "เข้าสู่ระบบสำเร็จ",
              });
              await this.$store.dispatch("sendMessage", "เข้าสู่ระบบสำเร็จ");

              await vm.$liff.closeWindow();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
            }
          });
      }
    },
    forgetpass() {
      this.$store.dispatch("setview", "FormForgetpassword");
    },
  },
};
</script>

<style lang="scss" scoped></style>
